module.exports = "/_next/static/images/np-c8a8ef36fe3edf227592d80461c5bb19.svg";